import { ProductsApiService } from '@shared/services/products-api.service';
import { BakeriesApiService } from '@shared/services/bakeries-api.service';
import { LayoutContextService } from '@shared/services/layout-context.service';
import { EditingCakeSessionService } from '@shared/services/editing-cake-session.service';
import { ContextProviderService } from '@shared/services/context-provider.service';
import { NotFoundService } from '@shared/services/not-found.service';
import { KeywordsFetcherService } from '@shared/services/keywords-fetcher.service';
import { SsrResponseManager } from '@shared/services/ssr-response-manager.service';

export const services = {
  ProductsApiService,
  BakeriesApiService,
  LayoutContextService,
  EditingCakeSessionService,
  ContextProviderService,
  NotFoundService,
  KeywordsFetcherService,
  SsrResponseManager,
};
